import InformationSecurityPolicy from "./information-security-policy.page";

export default InformationSecurityPolicy;
